import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import useDeviceType from "../common/useDeviceType";

/** 배너 슬라이드에 사용할 이미지 목록 */
const bannerSlides = [
  {
    pc: "/images/bannerPc1.png",
    mo: "/images/bannerMo1.png",
    alt: "하수구 고압세척 출장전문 수도권 365일 긴급출동",
  },
  {
    pc: "/images/bannerPc2.png",
    mo: "/images/bannerMo2.png",
    alt: "100% 해결 가능합니다 미해결시 비용 ZERO",
  },
];

export default function SMHeroBanner() {
  const isMobile = useDeviceType();

  return (
    <section className="relative w-full">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={800}
        loop
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        className="hero-swiper w-full"
      >
        {bannerSlides.map((slide) => (
          <SwiperSlide key={slide.pc}>
            <img
              className="w-full"
              src={isMobile ? slide.mo : slide.pc}
              alt={slide.alt}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
